// args for fetching
export var NIKE_BRAND = 'NIKE';
export var NIKECOM_CHANNEL = 'NIKECOM';
export var DOTCOM_UX_ID = 'com.nike.commerce.nikedotcom.web'; // url related

export var NIKE_DOMAIN = '.nike.com';
export var NIKECLOUD_DOMAIN = '.nikecloud.com';
export var CONVERSE_DOMAIN = '.converse.com';
export var HURLEY_DOMAIN = '.hurley.com';
export var HTTPS_WWW = 'https://www';
export var STORE_HOST = "https://store".concat(NIKE_DOMAIN);
export var SECURE_STORE_HOST = "https://secure-store".concat(NIKE_DOMAIN);
export var NIKE_API_HOST = "https://api".concat(NIKE_DOMAIN);
export var NIKE_DOTCOM_HOST = "".concat(HTTPS_WWW).concat(NIKE_DOMAIN);
export var CONVERSE_DOTCOM_HOST = "".concat(HTTPS_WWW).concat(CONVERSE_DOMAIN); // ux testing prod has the benefit of going through akamai and is closest to prod behavior on nikecloud.com

export var UX_TESTING_PROD_HOST = "https://uxtesting.prod.commerce".concat(NIKECLOUD_DOMAIN); // NOTE - the following do NOT go through akamai and are a vulnerability to access for external vendors such as applause
// the experience prod and test domains are available only if you're behind the vpn or at WHQ
// - please use uxtesting.prod.commerce.nikecloud.com instead for those cases

export var EXPERIENCE_PROD_HOST = "https://experience.prod.commerce".concat(NIKECLOUD_DOMAIN);
export var EXPERIENCE_TEST_HOST = "https://experience.test.commerce".concat(NIKECLOUD_DOMAIN); // for assets use akamai fronted www.nike.com/assets when possible

export var PROD_ASSETS_HOST = "".concat(NIKE_DOTCOM_HOST, "/assets"); // in case you need alternate assets for testing purposes, use assets.test

export var TEST_ASSETS_HOST = "https://assets.test.commerce.nikecloud.com";